export const SET_FAQ = "SET_FAQ";
const mutations = {
  [SET_FAQ]: (state, faq) => {
    state.faq = faq;
  }
};
export default mutations;